import templateUrl from '../views/modals/single-message-modal.tpl.html';
import ContactSingleMessageModalController from '../controllers/modals/single-send/contact-single-message-modal';

export default function contactSingleMessageModalCreator($injector, contact, extendedInformation) {
    extendedInformation = _.isObject(extendedInformation) ? extendedInformation : {};
    return $injector.get('$uibModal').open({
        controller: ContactSingleMessageModalController,
        controllerAs: 'vm',
        size: 'xlg',
        templateUrl,
        backdrop: 'static',
        windowClass: 'modal-fixed',
        keyboard: false,
        resolve: {
            extendedInformation: () => ({
                ...extendedInformation,
                recipientModel: contact,
                contact
            })
        }
    }).result;
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/helpers/contact-single-message-modal-creator.js